/**
 * 初始化
 * @param {type:temp/local/global/server} options
 * @returns {}
 */
function cache(options) {
    this._init(options);
}

function cacheinit(cache) {
    cache.prototype._init = function (options) {
        var localcache = {
            sign: new Date(),
            cache: {},
            get: function (key) {
                var obj = window.localStorage.getItem(localcache.sign + key);
                if (!obj)
                    return null;
                else {
                    return JSON.parse(obj).data;
                }
            },
            set: function (key, data) {
                var sdata = {
                    data: data
                };
                window.localStorage.setItem(localcache.sign + key, JSON.stringify(sdata));
                return true;
            }
        };
        var globalcache = {
            sign: 'global',
            cache: {},
            get: function (key) {
                var obj = window.localStorage.getItem(globalcache.sign + key);
                if (!obj)
                    return null;
                else {
                    return JSON.parse(obj).data;
                }
            },
            set: function (key, data) {
                var sdata = {
                    data: data
                };
                window.localStorage.setItem(globalcache.sign + key, JSON.stringify(sdata));
                return true;
            }
        };
        var tempcache = {
            sign: 'temp',
            cache: {},
            get: function (key) {
                return tempcache.cache[key];
            },
            set: function (key, value) {
                tempcache.cache[key] = value;
                return true;
            }
        };
        var self = this;
        self.sign = options.type === 'global' ? 'global' : options.type === 'local' ? new Date() : options.type === 'server' ? 'server' : 'temp';
        self._cache = {}; //相当与缓存管理器与索引列表,使得缓存不同类型key不能相同
        self._factory = {
            get: function (data) {
                var result;
                if (data.sign === 'temp') {
                    result = tempcache.get(data.key);
                } else if (data.sign === 'server')
                    return null;
                else if (data.sign === 'local') {
                    result = localcache.get(data.key);
                } else if (data.sign === 'global') {
                    result = globalcache.get(data.key);
                } else {
                    throw '没有此缓存类型' + data.sign;
                }
                return result;
            },
            set: function (sign, key, value) {
                if (sign === 'temp') {
                    return tempcache.set(key, value);
                } else if (sign === 'server')
                    return false;
                else if (sign === 'local') {
                    return localcache.get(key);
                } else if (sign === 'global') {
                    return globalcache.set(key, value);
                } else {
                    throw '没有此缓存类型' + sign;
                }
            }
        };
        self.isValid = function (data) {
            return data && data.valid;
        };
        self.haskey = function (key) {
            //使不同类型缓存具有相同验证规则
            //todo:过期时间验证
            return self._cache[key] && self._cache[key].valid;
        };

        self.get = function (key) {
            var data = self._cache[key];
            if (self.isValid(data)) {
                return self._factory.get(data);
            } else
                return null;
        };
        self.add = function (key, value, sign) {
            var data = self._cache[key];
            if (self.haskey(data)) {
                throw '存在key:' + key;
            } else {
                sign = sign || self.sign;
                if (self._factory.set(sign, key, value)) {
                    self._cache[key] = {
                        sign: sign,
                        key: key,
                        valid: true,
                        date: new Date()
                    };
                    return true;
                }
                return false;
            }
        };
        self.update = function (key, value, sign) {
            var data = self._cache[key];
            if (self.haskey(data)) {
                sign = sign || self.sign;
                if (self._factory.set(sign, key, value)) {
                    self._cache[key] = {
                        sign: sign,
                        key: key,
                        valid: true,
                        date: new Date()
                    };
                    return true;
                }
                return false;
            } else {
                throw '不存在key:' + key;
            }
        };
        self.force = function (key, value, sign) {
            sign = sign || self.sign;
            if (self._factory.set(sign, key, value)) {
                self._cache[key] = {
                    sign: sign,
                    key: key,
                    valid: true,
                    date: new Date()
                };
                return true;
            }
            return false;
        };
    };
}
cacheinit(cache);
export default cache;



// WEBPACK FOOTER //
// ./src/helpers/cache.js